import { FC } from "react";
import { DialogData, DialogHandle } from "../../types";
import { useApp } from "../../context/useApp";
import { Icon } from "../../parts/Icon";
import { _, parseNum } from "../../utils/helpers";
import { CHILDREN_PER_ADULT, DEFAULT_DIALOG_HANDLE } from "../../utils/symbols";

interface MaxChildrenDialogProps {
    dialogData: DialogData
}

export const MaxChildrenDialog: FC<MaxChildrenDialogProps> = ({dialogData}) => {

    const {
        state: { dialogHandles }
    } = useApp()

    if (dialogData.dialog !== 'max-children') return null

    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const handleUnderstood = () => {
        dialogHandle.closeDialog()
    }

    return (
        <section
            className="df fd-c jcfs aic r3 section p-r py-10 px-13"
            aria-labelledby="dialog-title"
        >
            <Icon icon="tickets"/>
            <h2 id="dialog-title" className="text s20-400 center my-9">{_('3di_onlyo__',CHILDREN_PER_ADULT.toString())}</h2>
            <button 
                className="button black text s20-500 r3 px-10 py-7 b-0"
                onClick={handleUnderstood}
            >
                {_('0ge_under__')}
            </button>
            <button 
                className="button b-0 p-2 p-a zi-6 close df aic jcc"
                onClick={() => dialogHandle.closeDialog()}
                aria-label={_('0ar_close__')}
                role="button"
            >
                <Icon icon="close" aria-hidden/>
            </button>
        </section>
    )
}